import { render, staticRenderFns } from "./WorkResponsibilities.vue?vue&type=template&id=7b5e36f0"
import script from "./WorkResponsibilities.vue?vue&type=script&lang=js"
export * from "./WorkResponsibilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports